import nibTheme from '../nib';
const foundation = {
  ...nibTheme,
  id: 'foundation'
};
export default foundation;